"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeUuidBranded = exports.serializeUuidBranded = void 0;
const uuid_1 = require("../../uuid");
const serializeUuidBranded = (s) => s;
exports.serializeUuidBranded = serializeUuidBranded;
const deserializeUuidBranded = (s) => {
    let decodedValue;
    try {
        decodedValue = decodeURIComponent(s);
    }
    catch (e) {
        throw new Error("Invalid URI encoding");
    }
    return (0, uuid_1.brandUuid)(decodedValue);
};
exports.deserializeUuidBranded = deserializeUuidBranded;
//# sourceMappingURL=uuid.js.map